import { render, staticRenderFns } from "./AppFormSelect.vue?vue&type=template&id=144a8ee0"
import script from "./AppFormSelect.vue?vue&type=script&lang=js"
export * from "./AppFormSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports